import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import CancelIcon from '@material-ui/icons/Cancel'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { semiConfigContext } from '../Shrna'
import { useShrnaSearchTermLazyQuery } from '@src/queries/ShrnaProductSearchQuery.generated'
import { initialState } from '../Reducer'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import { shrnaRoute, useRouter } from '@src/routes'
import { ActiveLinkType } from '@src/routes/SemiConfigurators/products/shrna/Enum'
import { regex } from '@src/routes/SemiConfigurators/utils/util'
import { SemiConfiguratorValues } from '../../../utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
    margin: theme.spacing(2, 0, 2, 0),
  },
  textarea: {
    fontFamily: 'inherit',
    margin: theme.spacing(1, 25, 0, 0),
    borderRadius: '5px',
    resize: 'none',
    height: 'auto',
    width: theme.spacing(100),
  },
  filter: {
    margin: theme.spacing(1, 0, 2, 0),
    fontSize: theme.typography.pxToRem(16),
  },
  form: {
    padding: theme.spacing(0, 6, 0, 2),
  },
  fontSize2: {
    fontSize: theme.typography.pxToRem(12),
  },
  formList: {
    padding: theme.spacing(0, 1, 0, 0),
    margin: theme.spacing(0),
    color: theme.palette.grey[300],
  },
  margin: {
    margin: theme.spacing(4, 0, 2, 0),
  },
  marginLeft: {
    margin: theme.spacing(2, 2, 0, 0),
    alignSelf: 'left',
  },
  contentWraper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  chip: {
    padding: theme.spacing(2, 0, 0, 2),
  },

  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
}))

const SearchTerms = () => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(semiConfigContext)
  const router = useRouter()
  const [getShrnaSearchTerm, { data, loading }] = useShrnaSearchTermLazyQuery()

  const searchResult = async (obj) => {
    await getShrnaSearchTerm({ variables: { input: obj } })
  }

  const getChipValue = (event, keys) => {
    dispatch({ type: 'SET_IS_ALL_CHECKED', data: false })
    dispatch({ type: 'SET_PAGINATION_PAGE', data: 1 })
    if (state.stepNo !== 1) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
      dispatch({
        type: 'UPDATE_DROP_DOWN',
        data: initialState.shrnaDropDownValue,
      })
      dispatch({
        type: 'UPDATE_DROPDOWN_RESPONSE',
        data: initialState.shrnaDropDownResponseList,
      })
      dispatch({
        type: 'UPDATE_PRICE_CALL_RESPONSE',
        data: initialState.priceCallResponse,
      })
      dispatch({
        type: 'UPDATE_PRICE_CALL',
        data: initialState.priceCallData,
      })
      dispatch({
        type: 'UPDATE_SPECIFICATION_VALUES',
        data: initialState.specificationValues,
      })
    }
    let ret = state.searchValue.term.replace(keys, '')
    ret = ret.replace('  ', ' ')

    ret = ret.trim()

    dispatch({
      type: 'UPDATE_SEARCH_TERM',
      data: { ...state.searchValue, term: ret, page: 1 },
    })
    const updateData = { ...state.searchValue, term: ret, page: 1 }

    searchResult(updateData)
  }

  React.useEffect(() => {
    if (state.searchValue.term.match(regex)) {
      dispatch({
        type: 'UPDATE_SEARCH_TERM',
        data: initialState.searchValue,
      })
    }
    if (!state.searchValue.term) {
      const url = `${shrnaRoute.index()}?activeLink=${
        ActiveLinkType.ProductSearch
      }`
      router.push(url)
    }
  }, [state.searchValue.term])

  const addChips = () => {
    const result = [] as any
    const terms = state.searchValue.term
    if (terms && terms.length > 0) {
      const totalChips = terms.split(/[\s, ]+/)
      const chips = [...new Set(totalChips)]
      chips.forEach((C) => {
        if (C) {
          result.push(
            <Chip
              variant="outlined"
              size="small"
              label={C}
              color="primary"
              icon={<CancelIcon onClick={(e) => getChipValue(e, C)} />}
              className={classes.marginLeft}
            />
          )
        }
      })
      return result
    }
    return terms
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getShrnaSearchTerm?.serverError) {
        dispatch({
          type: 'UPDATE_SEARCH_RESPONSE',
          data: data.getShrnaSearchTerm,
        })

        if (
          data.getShrnaSearchTerm.count !== null &&
          data.getShrnaSearchTerm.count !== undefined
        ) {
          dispatch({
            type: 'UPDATE_PAGINATION_DATA',
            data: {
              ...state.paginationData,
              totalCount: data.getShrnaSearchTerm.count,
            },
          })
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  return (
    <semiConfigContext.Provider value={{ state, dispatch }}>
      <div>
        <div className={classes.contentWraper}>
          <h2 className={classes.heading}>
            <FormattedMessage {...messages.CONF_SEARCH_TERMS} />
          </h2>

          <div className={classes.textarea}>
            <div className={classes.chip}>{addChips()}</div>
          </div>
        </div>
      </div>
      {loading && <CircleLoader />}
    </semiConfigContext.Provider>
  )
}

export default SearchTerms
